// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse.attributeTypeMap;
    }
}
PayloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse.discriminator = undefined;
PayloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse.additionalProperties = false;
PayloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse.js.map